var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTnstateBoard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_18045_3316)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1,
    width: 56,
    height: 56,
    rx: 12,
    fill: "url(#paint0_linear_18045_3316)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18045_3316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8401 23.2969H35.0078L39.2031 28.2969H45.0018V27.2536L41.8401 23.2969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1618 23.2969L21 27.2536V28.2969H26.7988L30.994 23.2969H24.1618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7032 39.5938V29.7031H38.5455L33.7031 23.9319V20.9062H37.7639V17H32.2969V23.9319L27.4546 29.7031H22.2969V39.5938H21V41H45V39.5938H43.7032ZM24.7657 32H26.1719V34H24.7657V32ZM26.208 38H24.8017V36H26.208V38ZM33 26.7969C34.2148 26.7969 35.2031 27.7852 35.2031 29C35.2031 30.2148 34.2148 31.2031 33 31.2031C31.7852 31.2031 30.7969 30.2148 30.7969 29C30.7969 27.7852 31.7852 26.7969 33 26.7969ZM36.7031 39.5938H35.2969V34.7031H33.7031V39.5938H32.2969V34.7031H30.7031V39.5938H29.2969V33.2969H36.7031V39.5938ZM41.1983 38H39.7921V36H41.1983V38ZM41.2343 34H39.8281V32H41.2343V34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 28.2031C32.5606 28.2031 32.2031 28.5606 32.2031 29C32.2031 29.4394 32.5606 29.7969 33 29.7969C33.4394 29.7969 33.7969 29.4394 33.7969 29C33.7969 28.5606 33.4394 28.2031 33 28.2031Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_18045_3316",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_18045_3316"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18045_3316"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_18045_3316"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_18045_3316",
    result: "effect2_dropShadow_18045_3316"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_18045_3316",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18045_3316",
    x1: 5,
    y1: 1,
    x2: 61,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7B277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7C1D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18045_3316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(21 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTnstateBoard);
export default __webpack_public_path__ + "static/media/ic_tnstate_board.926e3b71f0108db2212e1d6e2eab3445.svg";
export { ForwardRef as ReactComponent };